/** Строка публичной афиши (функция public_events_feed): без ссылок оплаты и участников. */
export type PublicEventFeedRow = {
  id: string;
  created_at: string | null;
  title: string;
  description: string | null;
  event_date: string | null;
  event_end_date: string | null;
  city: string;
  cover_image_url: string | null;
  max_attendees: number | null;
  organizer_user_id: string | null;
  price: string | null;
  event_type: string | null;
  audience_tag: string | null;
  has_ticket: boolean;
  co_organizer_user_id: string | null;
  co_organizer_name: string | null;
  topics: string[] | null;
  signup_via_organizer: boolean | null;
  organizer_name: string | null;
  organizer_photo_url: string | null;
  co_organizer_profile_name: string | null;
  co_organizer_photo_url: string | null;
  attendees_count: number;
  location_details: string | null;
};

/** Колонки, которые публичная функция имеет право отдавать гостю. */
export const PUBLIC_EVENT_FIELDS: readonly (keyof PublicEventFeedRow)[] = [
  "id", "created_at", "title", "description", "event_date", "event_end_date", "city",
  "cover_image_url", "max_attendees", "organizer_user_id", "price", "event_type", "audience_tag",
  "has_ticket", "co_organizer_user_id", "co_organizer_name", "topics", "signup_via_organizer",
  "organizer_name", "organizer_photo_url", "co_organizer_profile_name", "co_organizer_photo_url",
  "attendees_count", "location_details",
];

/** Приводим к строке списка афиши. Ссылку на оплату гостю не отдаём — только признак «есть билеты». */
export function mapPublicEventRow(r: PublicEventFeedRow) {
  return {
    ...r,
    status: "published",
    ticket_url: r.has_ticket ? "#signin" : null,
  };
}
